import React from 'react';
import { FORMATTING_BUTTONS, BUTTON_TYPES, RichUtils, isAtomicBlockInSelection } from 'wix-rich-content-editor-common';
import TextSpoilerButton from './TextSpoilerButton.js';
import { SPOILER_TYPE } from '../types.js';
import { SpoilerButtonIcon } from 'wix-rich-content-plugin-commons';
import 'prop-types';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const createToolbar = ({
  t,
  getEditorState,
  setEditorState,
  experiments
}) => {
  const isDisabled = () => isAtomicBlockInSelection(getEditorState());
  return {
    //TODO: isMobile: true?
    TextButtonMapper: () => ({
      [FORMATTING_BUTTONS.SPOILER]: {
        component: (props) => /* @__PURE__ */ React.createElement(TextSpoilerButton, __spreadValues({ disabled: isDisabled() }, props)),
        externalizedButtonProps: {
          dataHook: "spoilerButton",
          type: BUTTON_TYPES.BUTTON,
          tooltip: t("Spoiler_Insert_Tooltip"),
          getLabel: () => t("Spoiler_Insert_Tooltip"),
          // TODO: need another key?
          getIcon: () => () => {
            var _a;
            return SpoilerButtonIcon({
              newFormattingToolbar: !!((_a = experiments == null ? void 0 : experiments.newFormattingToolbar) == null ? void 0 : _a.enabled)
            });
          },
          onClick: () => setEditorState(RichUtils.toggleInlineStyle(getEditorState(), SPOILER_TYPE)),
          isActive: () => getEditorState().getCurrentInlineStyle().has(SPOILER_TYPE),
          isDisabled: () => getEditorState().getSelection().isCollapsed()
        }
      }
    }),
    name: SPOILER_TYPE
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
